import type { ChangeEventHandler, HTMLAttributes, InputHTMLAttributes } from 'react'

export const variants = {
  DEFAULT: 'default',
  PANEL: 'panel'
} as const

export type Variants = typeof variants[keyof typeof variants]

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {
  checked: boolean
  variant?: Variants
}

export interface HandleProps extends HTMLAttributes<HTMLDivElement> {
  checked: boolean
  variant?: Variants
  onChange?: ChangeEventHandler<HTMLInputElement>
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: Variants
}

export type ToggleThemeVariant = {
  backgroundHandleActive: string
  backgroundHandleInactive: string
  backgroundToggleActive: string
  backgroundToggleInactive: string
  borderColorInactive: string
  borderColorActive: string
}

export type ToggleTheme = {
  [key in Variants]: ToggleThemeVariant
}
